import ConfigurationWrapper from '../3modules/Config/ConfigurationWrapper'
import useConfiguration from '../../services/configPage/useConfiguration'
import MapCentralizationAccordion from '../3modules/Config/MapCentralizationAccordion'
import useMapConfiguration from '../../services/configPage/useMapConfiguration'
import MarkerConfigAccordion from '../3modules/Config/MarkerConfigAccordion'
import EntityTypeMarkerConfigAccordion from '../../v2/components/EntityTypeMarkerConfigAccordion';
import IndustryTypeMarkerConfigAccordion from '../../v2/components/IndustryTypeMarkerConfigAccordion';

import ExecutiveEntityMarkerConfigAccordion from '../../v2/components/ExecutiveEntityMarkerConfigAccordion';

const MapConfiguration = () => {
  const { onEditMode, setOnEditMode, isSnackbarOpen, setIsSnackbarOpen, isLoading, setIsLoading } = useConfiguration();
  const {
    selectedCountry,
    setSelectedCountry,
    selectedProvince,
    setSelectedProvince,
    handleReset,
    handlePreview,
    handleSave,
    handleCancel,
    selectedCountryOriginal,
    selectedProvinceOriginal,
    options,
    setOptions,
    mapZoomValue,
    setMapZoomValue,
    entityTypeList,
    entityTypeColors,
    setEntityTypeColors,
    industryTypeList,
    industryTypeIcons,
    setIndustryTypeIcons,
    defaultMarker,
    executiveEntities,
    executiveEntityMarkers,
    setExecutiveEntityMarkers
  } = useMapConfiguration(onEditMode, setOnEditMode, setIsLoading, setIsSnackbarOpen);

    return (
      <ConfigurationWrapper header={'Map Configuration'} onEditMode={onEditMode} setOnEditMode={setOnEditMode}
                            handleCancel={handleCancel} isSnackbarOpen={isSnackbarOpen}
                            setIsSnackbarOpen={setIsSnackbarOpen} isLoading={isLoading} handleSave={handleSave}
                            handlePreview={handlePreview} resetToDefault={handleReset}>
        <MapCentralizationAccordion onEditMode={onEditMode} selectedCountry={selectedCountry}
                                    setSelectedCountry={setSelectedCountry}
                                    selectedProvince={selectedProvince} setSelectedProvince={setSelectedProvince}
                                    selectedCountryOriginal={selectedCountryOriginal}
                                    selectedProvinceOriginal={selectedProvinceOriginal}
                                    mapZoomValue={mapZoomValue} setMapZoomValue={setMapZoomValue} />
        <MarkerConfigAccordion onEditMode={onEditMode} options={options} setOptions={setOptions} />
        <ExecutiveEntityMarkerConfigAccordion onEditMode={onEditMode} entities={executiveEntities}
          markers={executiveEntityMarkers} setMarkers={setExecutiveEntityMarkers} />
        <EntityTypeMarkerConfigAccordion onEditMode={onEditMode} entityTypeList={entityTypeList}
                                         entityTypeColors={entityTypeColors}
                                         setEntityTypeColors={setEntityTypeColors} defaultMarker={defaultMarker} />
        <IndustryTypeMarkerConfigAccordion onEditMode={onEditMode} industryTypeList={industryTypeList}
                                           industryTypeIcons={industryTypeIcons}
                                           setIndustryTypeIcons={setIndustryTypeIcons} defaultMarker={defaultMarker} />
      </ConfigurationWrapper>
    )
}

export default MapConfiguration
